module.exports = __webpack_public_path__ + "static/media/pancake-swap.fad6b94f.svg";